import {
	CLEAR_LEAD_BY_ID_SUCCESS,
	GET_LEADS_SUCCESS,
	GET_LEADS_FAIL,
	GET_SALES_AGENTS_SUCCESS,
	GET_SALES_AGENTS_FAIL,
	GET_EXTRA_FORMS_SUCCESS,
	GET_EXTRA_FORMS_FAIL,
	GET_LEAD_BY_ID_SUCCESS,
	GET_LEAD_BY_ID_FAIL,
	DELETE_LEAD_BY_ID_SUCCESS,
	DELETE_LEAD_BY_ID_FAIL,
	SET_DEAL_STATUS_FILTER_BY_SUCCESS,
	SET_DEAL_STATUS_FILTER_BY_FAIL,
	CLEAR_DEAL_STATUS_FILTER_SUCCESS,
	CLEAR_DEAL_STATUS_FILTER_FAIL,
	SET_DEALS_SECTION,
} from './types';
import getAllLeads from '../../api/Leads/getAllLeads.api';
import { getAllSalesAgents } from '../../api/Deals/getAllSalesAgents.api';
import { getAllExtraDocs } from '../../api/Deals/getAllExtraDocs.api';
import getLead from '../../api/Leads/getLead.api';
import deleteLead from '../../api/Leads/deleteLead.api';
import getAppointmentDetail from '../../api/Leads/getAppointmentDetails.api';
import getPendingDocumentStatus from '../../api/Purchasers/getPendingDocumentStatus.api';
import { GET_LEADS_APPOINTMENT_SUCCESS } from './types';
import { GET_LEADS_APPOINTMENT_FAIL } from './types';
import { GET_PENDING_DOC_SUCCESS } from './types';
import { GET_PENDING_DOC_FAIL } from './types';

//get all the leads
export const getLeads = () => {
	return async (dispatch, getState) => {
		var state = getState();
		var userType = state.signIn.userType;
		try {
			getAllLeads(userType, (returned) => {
				console.log('get all leads returned', returned);
				dispatch(getLeadsSuccess(returned));
			});
		} catch (error) {
			dispatch(getLeadsFail(error));
		}
	};
};

//get all the sales agents
export const getSalesAgents = () => {
	console.log('running action getsalesagents');
	return async (dispatch) => {
		try {
			getAllSalesAgents((returned) => {
				console.log('action of getting sales agents', returned);
				dispatch(getAgentsSuccess(returned));
			});
		} catch (error) {
			dispatch(getAgentsFail(error));
		}
	};
};

//get the leads by id
export const getLeadById = (id) => {
	return async (dispatch) => {
		try {
			getLead(id).then((returned) => {
				// if (id !== null) {
				// 	returned['leadId'] = id;
				// }
				// console.log('getLeadById', returned);
				dispatch(getLeadByIdSuccess(returned));
			});
		} catch (error) {
			dispatch(getLeadByIdFail(error));
		}
	};
};

//delete the lead by id
export const deleteLeadById = (id) => {
	return async (dispatch) => {
		try {
			deleteLead(id).then((returned) => {
				dispatch(deleteLeadByIdSuccess(returned));
			});
		} catch (error) {
			dispatch(deleteLeadByIdFail(error));
		}
	};
};

//get all the extra forms (Co broker form, ammendment insert delete, etc)
export const getExtraForms = () => {
	return async (dispatch) => {
		try {
			getAllExtraDocs((returned) => {
				dispatch(getExtraFormsSuccess(returned));
			});
		} catch (error) {
			dispatch(getExtraFormsFail(error));
		}
	};
};

export const getAppointment = (leadId) => {
	console.log('get appointment lead id', leadId);
	return async (dispatch) => {
		try {
			getAppointmentDetail(leadId, (returned) => {
				console.log('getAppointment returned', returned);
				dispatch(getLeadsAppointmentSuccess(returned));
			});
		} catch (error) {
			dispatch(getLeadsAppointmentFail(error));
		}
	};
};

export const getOutForSignatureStatuses = (purchaserList) => {
	return async (dispatch) => {
		try {
			getPendingDocumentStatus(purchaserList, (returned) => {
				console.log('getOutForSignatureStatuses', returned);
				dispatch(getOutForSignatureStatusesSuccess(returned));
			});
		} catch (error) {
			dispatch(getOutForSignatureStatusesFail(error));
		}
	};
};

export const setDealStatusFilterBy = (filterTitle) => {
	return async (dispatch) => {
		try {
			dispatch(setDealStatusFilterBySuccess(filterTitle));
		} catch (error) {
			dispatch(setDealStatusFilterByFail(error));
		}
	};
};

export const clearDealStatusFilterBy = () => {
	return async (dispatch) => {
		try {
			dispatch(clearDealStatusFilterBySuccess());
		} catch (error) {
			dispatch(clearDealStatusFilterByFail(error));
		}
	};
};

export const clearLeadByID = () => {
	return async (dispatch) => {
		dispatch(clearLeadByIDSuccess());
	};
};

export const setDealsSection = (payload) => ({
	type: SET_DEALS_SECTION,
	payload,
});

export const clearDealStatusFilterBySuccess = (payload) => ({
	type: CLEAR_DEAL_STATUS_FILTER_SUCCESS,
	payload,
});

export const clearDealStatusFilterByFail = (payload) => ({
	type: CLEAR_DEAL_STATUS_FILTER_FAIL,
	payload,
});

export const setDealStatusFilterBySuccess = (payload) => ({
	type: SET_DEAL_STATUS_FILTER_BY_SUCCESS,
	payload,
});

export const setDealStatusFilterByFail = (payload) => ({
	type: SET_DEAL_STATUS_FILTER_BY_FAIL,
	payload,
});

export const getOutForSignatureStatusesSuccess = (payload) => ({
	type: GET_PENDING_DOC_SUCCESS,
	payload,
});

export const getOutForSignatureStatusesFail = (payload) => ({
	type: GET_PENDING_DOC_FAIL,
	payload,
});

export const getLeadsAppointmentSuccess = (payload) => ({
	type: GET_LEADS_APPOINTMENT_SUCCESS,
	payload,
});

export const getLeadsAppointmentFail = (payload) => ({
	type: GET_LEADS_APPOINTMENT_FAIL,
	payload,
});
export const getLeadsSuccess = (payload) => ({
	type: GET_LEADS_SUCCESS,
	payload,
});

export const getLeadsFail = (payload) => ({
	type: GET_LEADS_FAIL,
	payload,
});

export const getLeadByIdSuccess = (payload) => ({
	type: GET_LEAD_BY_ID_SUCCESS,
	payload,
});

export const getLeadByIdFail = (payload) => ({
	type: GET_LEAD_BY_ID_FAIL,
	payload,
});

export const deleteLeadByIdSuccess = (payload) => ({
	type: DELETE_LEAD_BY_ID_SUCCESS,
	payload,
});

export const deleteLeadByIdFail = (payload) => ({
	type: DELETE_LEAD_BY_ID_FAIL,
	payload,
});

export const getAgentsSuccess = (payload) => ({
	type: GET_SALES_AGENTS_SUCCESS,
	payload,
});

export const getAgentsFail = (payload) => ({
	type: GET_SALES_AGENTS_FAIL,
	payload,
});

//extra forms
export const getExtraFormsSuccess = (payload) => ({
	type: GET_EXTRA_FORMS_SUCCESS,
	payload,
});

export const getExtraFormsFail = (payload) => ({
	type: GET_EXTRA_FORMS_FAIL,
	payload,
});

const clearLeadByIDSuccess = (payload) => ({
	type: CLEAR_LEAD_BY_ID_SUCCESS,
	payload,
});
